module.exports = __webpack_public_path__ + "img/Empty_ job_ alert.ac4673a9.svg";